import {AddressModuleConfiguration} from "./address.module.configuration";
import {StatePickerComponent} from "./component/state-picker/state-picker.component";
import {AddressFormComponent} from "./component/address-form/address-form.component";
import {AddressService} from "./service/address.service";
import {AddressServiceName} from "../utils/names/serviceNames";
import {AddressControlSubmitController} from "./component/address-controls/submit/address-control-submit";
import {AddressControlVerifyController} from "./component/address-controls/verify/address-control-verify";
import {AddressInputController} from "./component/address-input/address-input.controller";
import {AddressValidityInfoComponent} from "./component/address-validity-info/address-validity-info.component";
import {AddressManualOverride} from "./component/address-controls/force-submit/address-manual-override.component";

AddressModuleConfiguration.createNewModule()
    .component('statePicker', StatePickerComponent.instance)
    .component('addressForm', AddressFormComponent.instance)
    .component('addressButtonVerify', AddressControlVerifyController.instance)
    .component('addressButtonSubmit', AddressControlSubmitController.instance)
    .component('addressButtonForceSubmit', AddressManualOverride.instance)
    .component('addressFormInputFields', AddressInputController.instance)
    .component('addressValidityInfo', AddressValidityInfoComponent.instance)
    .service(AddressServiceName, AddressService.instance);
